import React, { useState, useRef, useEffect } from 'react';
import { Select, SelectProps } from 'antd';
import { CategoryModal, CategoryModalRef } from './CategoryModal';
import { getCategoryTemplate } from '@/api/category-template';

export interface CategorySelectProps<ValueType = any> extends Omit<SelectProps<ValueType | ValueType[]>, 'options' | 'children'> {
  onCategoryKeyChange?: ((category_key: string) => void) | undefined;
}

export const CategorySelect: React.FC<CategorySelectProps> = (props) => {
  const categoryModalRef = useRef<CategoryModalRef>(null);
  const [innerValue, setInnerValue] = useState<string>();
  const [options, setOptions] = useState<SelectProps['options']>();

  const getDefaultOptions = async (categoryId: string) => {
    const {
      result: { category_name, id, category_key },
    } = await getCategoryTemplate<{ category_name: string; id: string; category_key: string }>({ id: categoryId });
    setInnerValue(id);
    setOptions([{ label: category_name, value: id }]);
    props.onCategoryKeyChange?.(category_key);
  };

  useEffect(() => {
    // console.log(props.value, options);
    if (props.value && !options?.length) {
      getDefaultOptions(props.value);
    }
  }, [props.value, options]);

  return (
    <>
      <CategoryModal
        ref={categoryModalRef}
        onChange={({ id, category_key, category_name }) => {
          setInnerValue(id);
          setOptions([{ label: category_name, value: id }]);
          props.onChange?.(id, []);
          props.onCategoryKeyChange?.(category_key);
        }}
      />
      <Select
        {...props}
        open={false}
        options={options}
        value={innerValue}
        onClick={() => {
          categoryModalRef.current?.open();
        }}
      />
    </>
  );
};

export default CategorySelect;
